import React from "react";

const Navbar = () => {
    return (
        <nav className="navbar">
            <h1>Tumwesigye Ronnie</h1>
            <div className="menu">
                <a>Home</a>
                <a>About</a>
                <a>Contact</a>
                <a>Projects</a>
                <a>Qualifications</a>
            </div>
        </nav>
    )
}

export default Navbar